
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner, alertController } from '@ionic/vue';
import { refreshOutline } from 'ionicons/icons';
import { leadApi, formatDateTime } from '../../salesLeads';

/** Transfer approvals (for bosses) and the requests I sent or received. Only the owner's boss can approve. */
export default defineComponent({
  name: 'SalesLeadTransfers',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner },
  data() {
    return { data: { to_approve: [], sent: [], received: [], decided_by_me: [] } as any, tab: 'approve', loading: true, refreshOutline };
  },
  computed: {
    tabs(): { key: string; label: string; count: number }[] {
      return [
        { key: 'approve', label: 'To approve', count: this.data.to_approve.length },
        { key: 'sent', label: 'Sent', count: 0 },
        { key: 'received', label: 'Received', count: 0 },
        { key: 'decided', label: 'Decided', count: 0 },
      ];
    },
    current(): any[] {
      return { approve: this.data.to_approve, sent: this.data.sent, received: this.data.received, decided: this.data.decided_by_me }[this.tab] || [];
    },
    emptyText(): string {
      return {
        approve: 'No transfer requests are waiting for you.',
        sent: 'You have not requested any transfers.',
        received: 'No leads have been transferred to you.',
        decided: 'You have not decided any transfers yet.',
      }[this.tab] || '';
    },
  },
  created() {
    this.load();
  },
  methods: {
    format: formatDateTime,
    name(user: any) {
      return user && user.name ? user.name : '—';
    },
    load() {
      this.loading = true;
      leadApi('transfers', {}, true).then(r => {
        this.data = r.data;
        this.loading = false;
        if (!this.data.to_approve.length && this.tab === 'approve') {
          this.tab = 'sent';
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    async decide(transfer: any, decision: string) {
      const prompt = await alertController.create({
        header: decision === 'approve' ? 'Approve transfer?' : 'Reject transfer',
        message: `${this.name(transfer.from_user)} → ${this.name(transfer.to_user)}`,
        inputs: [{ name: 'note', type: 'text', placeholder: decision === 'approve' ? 'Note (optional)' : 'Reason (required)' }],
        buttons: [
          { text: 'Cancel', role: 'cancel' },
          {
            text: decision === 'approve' ? 'Approve' : 'Reject',
            handler: (input: any) => {
              leadApi('decideTransfer', { transfer_id: transfer.id, decision, note: input.note }).then(async r => {
                const a = await alertController.create({ header: 'Done', message: r.data.message, buttons: ['OK'] });
                await a.present();
                this.load();
              }).catch(() => undefined);
            },
          },
        ],
      });
      await prompt.present();
    },
    cancel(transfer: any) {
      leadApi('cancelTransfer', { transfer_id: transfer.id }).then(() => this.load()).catch(() => undefined);
    },
  },
});
